import cx from 'classnames';
import styles from './Skeleton.module.scss';
import { FC } from 'react';

interface SkeletonLoaderProps {
  className?: string;
  variant?: string;
  height?: 'md' | 'lg';
  [key: string]: any;
}

export const SkeletonLoader: FC<SkeletonLoaderProps> = ({
  className = '',
  size = 'md',
  height = 'md',
  ...props
}) => {
  return (
    <div
      {...props}
      className={cx(
        styles['skeleton-loader'],
        className,
        styles['skeleton-loader--' + size],
        styles['skeleton-loader-height--' + height]
      )}
    />
  );
};
